import React, { useState } from 'react';
import { Box, Stack } from '@mui/material';
import { Step1 } from './step1';
import { Step2 } from './step2';
import { Step3 } from './step3';
import ContainerPainel from 'components/container_painel';
import useComunidadesRuraisTradicionaisStore from 'stores/forms/comunidades_rurais_tradicionais';
import { useNavigate } from 'react-router-dom';
import { FormikProps, useFormik } from 'formik';
import { FormularioComunidadesFormik } from 'interfaces/formularioComunidades.interface';
import { ROUTES } from 'routes/constants';
import { FormSteps } from 'components/forms/form-steps';

const FormularioComunidadesQuilombolasSteps: React.FC = () => {
  const navigate = useNavigate();
  const { setPartialForm, salvarComoCadastrado } = useComunidadesRuraisTradicionaisStore();

  const [activeStep, setActiveStep] = useState(0);
  const [open, setOpen] = useState(false);

  const formik: FormikProps<FormularioComunidadesFormik> = useFormik<FormularioComunidadesFormik>({
    initialValues: {
      anoReferencia: (new Date().getFullYear() - 1).toString(),
      assentamentos: [],
      comunidades: [],
    },
    onSubmit: async (values) => {
      setPartialForm('assentamentos', values.assentamentos);
      setPartialForm('comunidades', values.comunidades);
      await salvarComoCadastrado();
      navigate(ROUTES.PACOTE_FORMULARIOS);
    },
    validateOnMount: true,
  });

  const handleNext = () => setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
  const handleBack = () => {
    if (activeStep === 0) {
      navigate(-1);
    } else {
      setActiveStep((prev) => Math.max(prev - 1, 0));
    }
  };

  const steps = [
    'Informações Básicas',
    'Infraestrutura e Serviços',
    'Serviços Ambientais',
  ]

  return (
    <ContainerPainel
      pagina="Formulário Comunidades Rurais e Tradicionais"
      showBackButton={true}
    >
      <Stack marginX={'4rem'} paddingTop={'2rem'}>
        <FormSteps
          activeStep={activeStep + 1}
          edit={true}
          steps={steps}
        />

        <Box mt={2}>
          {activeStep === 0 && (
            <Step1
              onNext={handleNext}
              formik={formik}
              open={open}
              setOpen={setOpen}
              onBack={handleBack}
              stepAtual={activeStep + 1}
              totalSteps={steps.length}
            />
          )}
          {activeStep === 1 && (
            <Step2
              onNext={handleNext}
              formik={formik}
              open={open}
              setOpen={setOpen}
              onBack={handleBack}
              stepAtual={activeStep + 1}
              totalSteps={steps.length}
            />
          )}
          {activeStep === 2 && (
            <Step3
              onNext={handleNext}
              formik={formik}
              open={open}
              setOpen={setOpen}
              onBack={handleBack}
              stepAtual={activeStep + 1}
              totalSteps={steps.length}
            />
          )}
        </Box>
      </Stack>
    </ContainerPainel>
  );
};

export default FormularioComunidadesQuilombolasSteps;
